import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  DeathsAndDiseasesContainer: {
    display: 'flex',
    flexDirection: 'row'
  },

  DeathsAndDiseasesContainerContent: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',

    '&>*:nth-child(2)': {
      marginRight: 24,
      marginLeft: 24
    },

    '@media (max-width:767px)': {
      overflowX: 'scroll'
    }
  },

  propertiesContainer: {
    height: '100%',
    position: 'relative'
  },

  propertiesDivider: {
    width: 'calc(100% - 447px)'
  },

  propertiesTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },
  propertiesHeader: {
    width: '100%',
    gap: 8,
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: 33
    }
  },

  propertiesTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  DeathsAndDiseasesSubTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.h3.fontSize,
    fontWeight: 500
  },
  propertiesDividerSubTitle: {
    height: 1,
    width: '100%',
    backgroundColor: '#E5E5E5'
  },

  propertiesButtonContainer: {
    width: '100%',
    '& h1': {
      margin: '0 16px 0 0',
      cursor: 'pointer'
    },
    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      }
    }
  },

  propertiesPopup: {
    '& .popup__box': {
      height: 'auto'
    }
  },

  customButtonWrapper: {
    width: 'auto'
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',

    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  filterContainer: {
    '& .containerButtons': {
      display: 'flex',
      gap: '20px',
      marginBottom: '20px'
    }
  },
  usersPopup: {
    '& .popup__box': {
      width: '100%'
      // maxWidth: 950,
      // height: 580
    },

    '& .popup__main': {
      marginTop: 32,
      overflowY: 'unset',
      [theme.breakpoints.down('sm')]: {
        overflowY: 'auto'
      }
    },

    '& .containerButtons': {
      width: 'unset'
    }
  },

  noDataContainer: {
    '& p': {
      color: theme.app.colors.text.primary,
      fontSize: '16px',
      marginBottom: '20px'
    }
  }
}))
